export default "__VITE_ASSET__BybcuBab__"